var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form
    ? _c(
        "div",
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-col": _vm.labelCol,
                "wrapper-col": _vm.wrapperCol
              }
            },
            [
              _vm._l(_vm.formConfig, function(item) {
                return [
                  item.type == "input"
                    ? _c(
                        "a-form-model-item",
                        {
                          key: item.prop,
                          attrs: {
                            label: item.label,
                            prop: item.prop,
                            required: item.required,
                            placeholder: item.placeholder
                          }
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.form[item.prop],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.prop, $$v)
                              },
                              expression: "form[item.prop]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.type == "password"
                    ? _c(
                        "a-form-model-item",
                        {
                          key: item.prop,
                          attrs: {
                            label: item.label,
                            prop: item.prop,
                            required: item.required,
                            placeholder: item.placeholder
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.form[item.prop],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.prop, $$v)
                              },
                              expression: "form[item.prop]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c4cbd54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4cbd54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/edit-form/edit-form.vue
// module id = Y1oH
// module chunks = 1